module.exports = "pegasus_template/assets/theme5/facebook-icon.png";